import * as React from "react";
import { UitkText } from "uitk-react-text";
import { UitkSpacing, UitkSpacingProps } from "uitk-react-spacing";
import { useLocalization } from "@shared-ui/localization-context";
import { PackageConfig } from "stores/wizard/config";

export interface ValuePropSubtitleHotwireProps {
  config: PackageConfig;
  margin?: UitkSpacingProps["margin"];
  desktopViewPort?: boolean;
}

export const ValuePropSubtitleHotwire: React.FC<ValuePropSubtitleHotwireProps> = ({
  config,
  margin,
  desktopViewPort,
}) => {
  const { formatText } = useLocalization();

  return (
    <UitkSpacing margin={margin}>
      <UitkText size={400} theme={desktopViewPort ? "inverse" : "default"}>
        {formatText(config.pillsLabelKey)}
      </UitkText>
    </UitkSpacing>
  );
};
